import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import nodeflowHero from "../../../assets/img/Product/NodeFlow/nodeflow_hero.svg";

const NodeFlowPreview = () => {
  return (
    <div className="fancy-text-block-thirteen pt-80 md-pt-50" id="nodeflow">
      <div className="container">
        <div className="row align-items-center">
          <div
            className="col-lg-6 order-lg-last"
            data-aos="fade-left"
            data-aos-duration="1200"
          >
            <div className="title-style-two">
              <h6 style={{ color: "#2563eb", textTransform: "uppercase", letterSpacing: 1 }}>
                Workflow Orchestration
              </h6>
              <h2>NodeFlow</h2>
              <br />
            </div>
            <p>
              Connect GUIBuilder and CloudView with visual, node-based
              workflows. Automate application logic, create data pipelines,
              handle events and execute workflows in real time.
            </p>
            <br />
            <p>
              With 80+ nodes, MQTT, REST API, database and JavaScript scripting
              support, NodeFlow turns industrial automation into a drag-and-drop
              experience.
            </p>
            <div className="mt-20">
              <Link
                to="/nodeflow"
                className="theme-btn-two"
                style={{ textDecoration: "none" }}
              >
                Explore NodeFlow
                <FontAwesomeIcon
                  icon={faArrowRight}
                  style={{ marginLeft: "8px" }}
                />
              </Link>
            </div>
          </div>
          <div
            className="col-lg-6 col-md-8 m-auto order-lg-first"
            data-aos="fade-right"
            data-aos-duration="1200"
          >
            <Link to="/nodeflow">
              <img
                src={nodeflowHero}
                alt="NodeFlow visual workflow designer"
                className="w-100"
              />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export { NodeFlowPreview };
